import React, { useEffect, useState } from 'react';
import { omit } from 'lodash';

import { useSnackbar } from 'contexts/snackbar';
import { useUser2 } from 'contexts/user2';
import { Button, Form, IconButton, ResponsiveDialog, Stack, Text, TextInput } from 'shell/components';

const GroupNameEditModal = ({ open, onClose, onSubmit }) => {
    const { message } = useSnackbar();
    const { currentGroup } = useUser2();

    const defaultFormValues = {
        isDirty: false,
        name: currentGroup?.name,
    };

    const [form, setForm] = useState(defaultFormValues);
    const [errors, setErrors] = useState({ name: '' });

    const handleChange = (key, value) => {
        return setForm((current) => ({ ...current, isDirty: true, [key]: value }));
    };

    const handleSubmit = () => {
        onSubmit(omit(form, ['isDirty']));
        onClose();
        message.success('Team name was successfully updated.');
    };

    useEffect(() => {
        if (!open) setForm(defaultFormValues);
    }, [open]);

    useEffect(() => {
        if (currentGroup) setForm(defaultFormValues);
    }, [currentGroup]);

    useEffect(() => {
        if (!form) return;
        setErrors((current) => ({ ...current, name: form.name ? '' : 'Team name is required.' }));
    }, [form]);

    const canSubmit = form.isDirty && !Boolean(Object.values(errors).reduce((acc, cur) => cur + acc, ''));

    return (
        <ResponsiveDialog open={open} onClose={onClose}>
            <Stack sx={{ minWidth: 300 }} spacing={4}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text variant={'h6'}>Edit Team Information</Text>
                    <IconButton kind={'exit'} size={'medium'} variant={'square'} onClick={onClose} />
                </Stack>
                <Form onSubmit={handleSubmit}>
                    <Stack alignItems={'flex-end'} spacing={4}>
                        <TextInput
                            error={Boolean(errors.name)}
                            helperText={errors.name}
                            label={'Team Name'}
                            required
                            value={form.name}
                            onChange={(e) => handleChange('name', e.target.value)}
                        />
                        <Button sx={{ alignSelf: 'flex-end' }} disabled={!canSubmit} type={'submit'}>
                            Update
                        </Button>
                    </Stack>
                </Form>
            </Stack>
        </ResponsiveDialog>
    );
};

export default GroupNameEditModal;
